/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-10 10:54:27
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-10 10:55:36
 * @FilePath: \zhucai_user\src\api\order.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/request";

export function CreateOrders(data) {
  return request({
    url: "/pc/Orders/CreateOrders",
    method: "post",
    data,
  });
}

export function Orders_GetPayConfirm(params) {
  return request({
    url: "/pc/Orders/Orders_GetPayConfirm",
    method: "get",
    params,
  });
}
export function AliPayPC(params) {
  return request({
    url: "/pc/Orders/AliPayPC",
    method: "get",
    params,
  });
}
export function WxPayPC(params) {
  return request({
    url: "/pc/Orders/WxPayPC",
    method: "get",
    params,
  });
}
export function CheckPayStatus(params) {
  return request({
    url: "/pc/Orders/CheckPayStatus",
    method: "get",
    params,
  });
}
